<template>
	<div class="wrapperddiv">
		<!-- 卡片试图区域 -->
		<el-card>
			<div slot="header" class="clearfix">
			  <span>角色管理</span>
			</div>
			<!-- 添加角色按钮区域 -->
			<el-row>
				<el-col>
					<el-button type="primary" @click="addrolename">添加角色</el-button>
					</el-col>
				</el-row>
				<!-- 角色列表区域 -->
				<el-table
				:data="rolelist"
				border
				stripe
				row-key="rid"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				>
				<!-- 索引列 -->
				<!-- 	<el-table-column
					  type="index"
					 >
					</el-table-column> -->
					<el-table-column
					  prop="rolename"
					  label="角色名称">
					</el-table-column>
					<el-table-column
					  prop="roleDesc"
					  label="角色描述">
					</el-table-column>
					<el-table-column
					  label="操作">
						<template slot-scope="scope">
				<el-button 
				type="primary" 
				size="mini" 
				icon="el-icon-edit"
				 @click="showRoleEditDialog(scope.row.rid)"
				 v-if="scope.row.type != 1"
				>编辑</el-button>
				<el-button type="danger"  size="mini"  icon="el-icon-delete" @click="removeRoleById(scope.row)">删除</el-button>

          <el-button 
		  type="warning" 
		  size="mini"  
		  icon="el-icon-setting" 
		  @click="showSetRightDialog(scope.row)"
		  v-if="scope.row.type != 1"
		  >分配权限</el-button>
						</template>
					</el-table-column>
					</el-table>
			</el-card>
			<!-- 添加角色的对话框 -->
			<el-dialog
			  title="添加角色"
			  :visible.sync="addRoleDialogVisible"
			  width="50%"
			  @close="addRoleDialogClosed"
			>
			  <!-- 内容主体区域 -->
			 <el-form
			 :rules="addRoleFormRules"
			 ref="addRoleFormRef"
			 :model="addRoleForm"
			 label-width="100px">
			   <el-form-item label="角色名称" prop="rolename">
			     <el-input v-model="addRoleForm.rolename"></el-input>
			   </el-form-item>
			   <el-form-item label="角色描述" prop="roleDesc">
			     <el-input v-model="addRoleForm.roleDesc"></el-input>
			   </el-form-item>
			   <el-form-item label="父级名称" prop="rid">
			    <el-select 
				v-model="addRoleForm.rid" 
				placeholder="请选择父级名称" 
				style="width: 100%;" 
				@change="choose">
			        <el-option
			          v-for="item in ridlist"
			          :key="item.rid"
			          :label="item.rolename"
			          :value="item.rid"
			    	   				 >
			        </el-option>
			      </el-select>
			   </el-form-item>
			   <el-form-item label="目录等级" prop="type">
			    <el-select 
			   				v-model="addRoleForm.type" 
			   				placeholder="请选择目录等级" 
			   				style="width: 100%;" >
			        <el-option
			          v-for="item in Rightlist"
			          :key="item.type"
			          :label="item.label"
			          :value="item.type"
			    	   				 >
			        </el-option>
			      </el-select>
			   </el-form-item>
			   </el-form>
			  <!-- 底部区域 -->
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="addRoleDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="addRole">确 定</el-button>
			  </span>
			</el-dialog>
			<!-- 编辑角色的对话框 -->
			<el-dialog
			  title="编辑角色"
			  :visible.sync="editRoleDialogVisible"
			  width="50%"
			  @close="editRoleDialogClosed"
			>
			  <!-- 内容主体区域 -->
			 <el-form
			 :rules="editRoleFormRules"
			 ref="editRoleFormRef"
			 :model="editRoleForm"
			 label-width="100px"
			 >
			   <el-form-item label="角色名称" prop="rolename">
			     <el-input v-model="editRoleForm.rolename"></el-input>
			   </el-form-item>
			   <el-form-item label="角色描述" prop="roleDesc">
			     <el-input v-model="editRoleForm.roleDesc"></el-input>
			   </el-form-item>
			   <el-form-item label="父级名称" prop="erid">
			    <el-select 
			   				v-model="editRoleForm.erid" 
			   				placeholder="请选择父级名称" 
			   				style="width: 100%;" 
			   				@change="editchoose">
			        <el-option
			          v-for="item in ridlist"
			          :key="item.rid"
			          :label="item.rolename"
			          :value="item.rid"
			    	   				 >
			        </el-option>
			      </el-select>
			   </el-form-item>
			   <el-form-item label="目录等级" prop="type">
			    <el-select 
			   				v-model="editRoleForm.type" 
			   				placeholder="请选择目录等级" 
			   				style="width: 100%;" >
			        <el-option
			          v-for="item in Rightlist"
			          :key="item.type"
			          :label="item.label"
			          :value="item.type"
			    	   				 >
			        </el-option>
			      </el-select>
			   </el-form-item>
			   </el-form>
			  <!-- 底部区域 -->
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="editRoleDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="editRole">确 定</el-button>
			  </span>
			</el-dialog>
			<!-- 分配权限的对话框 -->
			<el-dialog
			  title="分配权限"
			  :visible.sync="setRightDialogVisible"
			  width="50%"
			  @close="setRightDialogClosed"
			  >
			  <!--  check-strictly这个属性父节点与子节点互不关联！！！！！！！！！！！！！！！！！-->
			  <el-tree
			  :data="rightslist"
			  :props="treeProps"
			  show-checkbox
			  node-key="pid"
			  default-expand-all
			  :default-checked-keys="defKeys"
			  ref="treeRef"
			  check-strictly
			  >
			  </el-tree>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="setRightDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="allRights">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				//所有角色列表数据
				rolelist:[],
				//控制分配权限对话框的显示与隐藏
				setRightDialogVisible:false,
				//所有权限的数据
				rightslist:[],
				// //树形控件的属性绑定对象
				treeProps:{
					label:'label',
					children:'children'
				},
				// //默认选中的节点Id值
				 defKeys:[],
				// //当前即将分配权限的角色id
				 roleId:'',
				 //菜单权限的信息
				 rightId:'',
				//控制添加角色对话框的显示与隐藏
				addRoleDialogVisible:false,
				//添加角色的表单数据
				addRoleForm:{
					rolename:'',
					roleDesc:'',
                    rid:'',
					type:''
				},
				//添加角色的表单验证
				addRoleFormRules:{
					rolename:[
						{required:true,message:'请输入角色名称',trigger:'blur'},
						{min:2,max:10,message:'角色名称的长度在2~10字符之间',trigger:'blur'}
					],
					rid:[
						{required:true,message:'请选择父级名称',trigger:'change'},
					],
					type:[
						{required:true,message:'请选择目录等级',trigger:'change'},
					],
				},
				//控制编辑角色对话框的显示与隐藏
				editRoleDialogVisible:false,
				//编辑角色的表单数据
				editRoleForm:{},
				//编辑角色的表单验证
				editRoleFormRules:{
					rolename:[
						{required:true,message:'请输入角色名称',trigger:'blur'},
						{min:2,max:10,message:'角色名称的长度在2~10字符之间',trigger:'blur'}
					],
					erid:[
						{required:true,message:'请选择父级名称',trigger:'change'},
					],
					type:[
						{required:true,message:'请选择目录等级',trigger:'change'},
					],
				},
				ridlist:[],
				//等级
				Rightlist:[],
			}
		},
		created(){
			this.getRolesList()
		},
		methods:{
			//获取所有角色的列表
			async getRolesList(){
				const {data:res} = await this.$http.getrolesTreeList()
				if (res.status !==0){
					return this.$message.error('获取角色列表失败!')
				}
				this.rolelist = res.data
			},
			async getbpRolesList(){
				const {data:res} = await this.$http.getrolesList()
				if (res.status !==0){
			     return this.$message.error('获取角色列表失败!')
				}
				const option1 = res.data
				const options =[{rid:0,rolename: '添加没有父级名称'}]
					//使用ES6扩展运算符…合并
					let arry = [
						...options,
						...option1
					]
				this.ridlist = arry
			},
			addrolename(){
				this.getbpRolesList()
				this.addRoleDialogVisible = true	
			},
			choose(val){
				var obj = {}
				obj = this.ridlist.find(function(i){
					return i.rid === val 
				})
				//联动等级下拉框
				if(obj.type==undefined){
					this.Rightlist=[]
					this.addRoleForm.type=''
					this.Rightlist.push({
					   type: '1',
					   label: '一级目录'
					})
				}else if(obj.type=='1'){
					 this.Rightlist=[]
					 this.addRoleForm.type=''
					 this.Rightlist.push({
					    type: '2',
					    label: '二级目录'
					 })
				}else if(obj.type=='2'){
					    this.Rightlist=[]
						this.addRoleForm.type=''
					    this.Rightlist.push({
					    type: '3',
					    label: '三级目录'
					 })
				}
			},
		 addRole(){
			 const addRoleData = {
				 Fidrole:this.addRoleForm.rid,
				 roleDesc:this.addRoleForm.roleDesc,
				 type:this.addRoleForm.type,
				 rolename:this.addRoleForm.rolename
			 }
				this.$refs.addRoleFormRef.validate(async valid =>{
					if (!valid) return
					const {data:res} = await this.$http.addroles(addRoleData)
					if (res.status !==0){
						return this.$message.error('添加角色失败!')
					}
					this.$message.success('添加角色成功!')
					//隐藏添加角色的对话框
					this.addRoleDialogVisible = false
					//重新获取角色列表数据
					this.getRolesList()
					})
			},
			//监听添加角色对话框的关闭
			addRoleDialogClosed(){
				this.Rightlist=[]
				this.$refs.addRoleFormRef.resetFields()
			},
			//展示编辑角色的对话框
				async showRoleEditDialog(id){
					const {data:res} = await this.$http.byIdroles(id)
					if (res.status !==0){
						return this.$message.error('查询角色信息失败!')
					}
					this.getbpRolesList()
					this.Rightlist.push({
					   type:res.data.type,
					   //三目运算符，三个条件写法
					   label:res.data.type=='1'?'一级目录':(res.data.type=='2'? '二级目录':'三级目录')
					})
					 this.editRoleForm = res.data
					// this.editRoleForm.rolename = res.data.rolename
					// this.editRoleForm.roleDesc = res.data.roleDesc
					// this.editRoleForm.type = res.data.type 
					  this.editRoleForm.erid = res.data.Fidrole
					console.log(this.editRoleForm)
					this.editRoleDialogVisible = true
				},
				editchoose(val){
					console.log(111)
				var obj = {}
				obj = this.ridlist.find(function(i){
					return i.rid === val 
				})
				//联动等级下拉框
				if(obj.type==undefined){
					this.Rightlist=[]
					this.editRoleForm.type=''
					this.Rightlist.push({
					   type: '1',
					   label: '一级目录'
					})
				}else if(obj.type=='1'){
					 this.Rightlist=[]
					 this.editRoleForm.type=''
					 this.Rightlist.push({
					    type: '2',
					    label: '二级目录'
					 })
				}else if(obj.type=='2'){
					    this.Rightlist=[]
						this.editRoleForm.type=''
					    this.Rightlist.push({
					    type: '3',
					    label: '三级目录'
					 })
				}	
				},
			//修改角色信息并提交
			editRole(){
				console.log(this.editRoleForm)
				const editRoleFormData={
					rid:this.editRoleForm.rid,
					rolename:this.editRoleForm.rolename,
					roleDesc:this.editRoleForm.roleDesc,
					Fidrole:this.editRoleForm.erid,
					type:this.editRoleForm.type
				}
				this.$refs.editRoleFormRef.validate(async valid =>{
					if (!valid) return
				const {data:res} = await this.$http.editRoles(editRoleFormData)
				if (res.status !==0){
					return this.$message.error('修改角色失败!')
				}
				this.$message.success('修改角色成功!')
				//隐藏修改角色的对话框
				this.editRoleDialogVisible = false
				//重新获取角色列表数据
				this.getRolesList()

				})
			},
			//监听修改角色对话框的关闭
			editRoleDialogClosed(){
				this.Rightlist=[]
				this.$refs.editRoleFormRef.resetFields()
			},

			//根据Id删除对应的角色信息
			async removeRoleById(data){
				console.log(data)
				//判断删除的选项有没有子数据
				if(data.children.length >0){
					return this.$message.error('请删除掉子选项数据！')
				}else{
				//弹框询问角色是否删除数据
				        const confirmResult = await this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).catch(err => err)
						if (confirmResult !== 'confirm'){
							return this.$message.info('已取消删除')
						}
						const {data:res} = await this.$http.delRoles(data.rid)
						if (res.status !==0){
							return this.$message.error('删除角色失败!')
						}
						this.$message.success('删除角色成功!')
						this.getRolesList()	
				}
				
			},
			// //展示分配权限的对话框
			async showSetRightDialog(role){
				this.rightId = role.pid
				this.roleId = role.rid
				const { data: res } = await this.$http.getAllMenu()
				this.rightslist = res.data
				//三目运算符做判断条件，如果新建的角色，pid为空null则给空数组，否则报错的
			    this.defKeys=this.rightId == null? []:this.rightId.split(",")
				console.log(this.defKeys)
				this.setRightDialogVisible = true
			},
			// //监听分配权限对话框的关闭事件
			setRightDialogClosed(){
				this.defKeys = []
			},
			// //点击为角色分配权限
			async allRights(){
				let keys = [
					...this.$refs.treeRef.getCheckedKeys(),
					...this.$refs.treeRef.getHalfCheckedKeys()
				]
				let idStr = keys.join(",")
				this.rightId = idStr
		        console.log(this.rightId)
				const {data:res} = await this.$http.savePowerRoles(
				{data:{
					rid:this.roleId,
					pid:this.rightId
				}}
				)
				if (res.status !==0){
				 return this.$message.error('更新权限失败!')
				}
				this.$message.success('更新权限成功!')
				this.setRightDialogVisible = false
				this.getRolesList()
                this.$store.dispatch('getMenus')

			}
			
		}
	}
</script>

<style lang="less" scoped>
	.el-tag{
		margin: 7px;
	}
	.bdtop{
		border-top: 1px solid #eee;
	}
	.bdbottom{
		border-bottom: 1px solid #eee;
	}
	.vcenter{
		display: flex;
		align-items: center;
	}
	@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
			margin-bottom: 100px;
		} 
	}
</style>
